import prepareSaveReseau from '@/services/catalogue/produitReseau/prepareSaveReseau';

export default function preparationEnvoiBackReseauTempo(produitReseauTempo) {
  const reseauTempo = prepareSaveReseau(produitReseauTempo);
  if (reseauTempo.couleurHtmlRgba) {
    const color = reseauTempo.couleurHtmlRgba.slice(7, 9)
      + reseauTempo.couleurHtmlRgba.slice(1, 7);
    reseauTempo.couleurArgb = parseInt(color, 16);
  }
  delete reseauTempo.couleurHtmlRgb;
  delete reseauTempo.couleurHtmlRgba;
  return reseauTempo;
}
